import { useEffect, useState, useCallback } from 'react';
import { apiFetch } from "../utils/api";

function useIncidents() {
  const [incidents, setIncidents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchIncidents = useCallback(() => {
    setLoading(true);
    setError(null);

    apiFetch('/api/incidents')
      .then(async (res) => {
        if (!res) {
          return;
        }

        if (res.status === 403) {
          // No tiene permisos → lista vacía
          setIncidents([]);
          return;
        }

        if (!res.ok) {
          const body = await res.json().catch(() => ({}));
          const err = new Error(body?.error || 'Error loading incidents');
          err.status = res.status;
          throw err;
        }

        return res.json();
      })
      .then((data) => {
        if (data) setIncidents(data);
      })
      .catch((err) => {
        console.error('Error loading Incidents:', err);
        setError(err);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchIncidents();
  }, [fetchIncidents]);

  return { incidents, loading, error, fetchIncidents };
}

export default useIncidents;
